import { type FC } from "react";
import { IconButton, Stack, TableCell, Tooltip, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import SmsIcon from "@mui/icons-material/Sms";

interface Props {
  phone: string;
  email: string;
  onOpenHelpdesk: () => void;
}

const ClientContactCell: FC<Props> = ({ phone, email, onOpenHelpdesk }) => (
  <TableCell sx={{ minWidth: 220, whiteSpace: "nowrap" }}>
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", flexWrap: "nowrap" }}>
      <PhoneIcon sx={{ fontSize: 16, color: "text.secondary", flexShrink: 0 }} />
      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {phone}
      </Typography>
      <Tooltip title="SMS / Helpdesk — otwórz kartę Helpdesk">
        <IconButton
          size="small"
          color="primary"
          onClick={onOpenHelpdesk}
          aria-label="Otwórz Helpdesk"
          sx={{ flexShrink: 0 }}
        >
          <SmsIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", flexWrap: "nowrap" }}>
      <EmailIcon sx={{ fontSize: 16, color: "text.secondary", flexShrink: 0 }} />
      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {email}
      </Typography>
    </Stack>
  </TableCell>
);

export default ClientContactCell;
